// app/javascript/custom/stream_actions.js
import {StreamActions} from "@hotwired/turbo"

StreamActions.dispatch_event = function () {
    // `this` === <turbo-stream> element
    // Grab the raw JSON string that the server put inside <template> … </template>
    const raw = this.templateElement.content.textContent.trim()
    if (!raw) return                                   // defensive guard

    const {name, detail = {}, bubbles = true, target = "document"} =
        JSON.parse(raw)

    const root =
        target === "document" ? document : document.querySelector(target) || document

    root.dispatchEvent(new CustomEvent(name, {detail, bubbles}))
}
